import { Children, useState } from "react";
import { Stepper, Step, StepLabel } from "@mui/material";

import { IStepperRootProps } from "./types";
import { StepperContext } from "./context";

export function StepperRoot({ onSubmit, children }: IStepperRootProps) {
  const [currentStep, setCurrentStep] = useState(0);
  const totalSteps = Children.count(children);

  function handleNextStep() {
    if (currentStep === totalSteps - 1) return onSubmit();

    setCurrentStep(currentStep + 1);
  }

  function handlePrevStep() {
    if (currentStep === 0) return;

    setCurrentStep(currentStep - 1);
  }

  function handleMoveStep(step: number) {
    setCurrentStep(step);
  }

  function handleSave() {
    onSubmit();
  }

  return (
    <>
      <Stepper activeStep={currentStep}>
        {Children.map(children, (child, index) => (
          <Step key={child.props.title}>
            <StepLabel>{child.props.title}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <StepperContext.Provider
        value={{
          handleNextStep,
          handlePrevStep,
          handleSave,
          isFirstStep: currentStep === 0,
          isLastStep: currentStep === totalSteps - 1,
        }}
      >
        <div>{children[currentStep]}</div>
      </StepperContext.Provider>
    </>
  );
}